/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useFloating, arrow, useClick, useInteractions, FloatingFocusManager } from '@floating-ui/react-dom-interactions';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import Icon from 'components/Icon/Icon';
import './InfoPopupModern.scss';

const InfoPopupModern = props => {
	const {
		size,
		iconWidth,
		iconName,
		leftShift,
		closeCopy,
		translate,
		children,
		helpText
	} = props;

	const [open, setOpen] = useState(false);
	const arrowRef = useRef();

	const {
		x,
		y,
		reference,
		floating,
		strategy,
		context,
		middlewareData: { arrow: { x: arrowX, y: arrowY } = {} }
	} = useFloating({
		open,
		onOpenChange: setOpen,
		placement: 'bottom',
		middleware: [arrow({ element: arrowRef })]
	});
	const {
		getReferenceProps,
		getFloatingProps
	} = useInteractions([
		useClick(context)
	]);

	const handleKey = e => {
		const { key } = e;
		if (key === 'Escape') {
			setOpen(false);
		}
		if (key === 'ArrowDown') {
			e.stopPropagation();
			// setOpen(false);
		}
	};

	return (
		<div className="info-popup-modern">

			<button
				className="info-popup-modern-icon"
				type="button"
				ref={reference}
				{...getReferenceProps()}>
				<Icon iconName={iconName} style={{ width: iconWidth }} />
				<span className="sr-only">{helpText || translate('openHelpContent')}</span>
			</button>
			{open && (
				<FloatingFocusManager context={context} modal={false}>
					<div
						className={`info-popup-modern-floating ${size}`}
						ref={floating}
						{...getFloatingProps()}
						style={{
							position: strategy,
							top: (y || 0),
							left: (x || 0) - leftShift
						}}>
						<div
							ref={arrowRef}
							className="info-popup-modern-floating-arrow"
							style={{
								position: 'absolute',
								width: '10px',
								height: '10px',
								left: arrowX != null ? `${arrowX + leftShift}px` : '',
								top: arrowY != null ? `${arrowY}px` : ''
							}} />
						<div className="info-popup-modern-floating-content">
							<div className="info-popup-modern-floating-header">
								<button
									type="button"
									onKeyUp={handleKey}
									onClick={() => setOpen(false)}>
									<span className="times-symbol" aria-hidden>&times;</span>
									<span className="sr-only">{closeCopy || translate('closeDialogueSrOnly')}</span>
								</button>
							</div>
							<div className="info-popup-modern-floating-body" tabIndex="0">
								{children}
							</div>
						</div>
					</div>
				</FloatingFocusManager>
			)}
		</div>
	);
};

InfoPopupModern.propTypes = {
	size: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	iconWidth: PropTypes.number,
	leftShift: PropTypes.number,
	iconName: PropTypes.string,
	closeCopy: PropTypes.string,
	translate: PropTypes.func,
	helpText: PropTypes.string
};

InfoPopupModern.defaultProps = {
	size: 'small',
	iconWidth: 14,
	iconName: 'info',
	leftShift: 0,
	closeCopy: null,
	translate: () => {},
	helpText: null
};

export default withTranslate(InfoPopupModern);
